<template>
    <div class="budget settings-section">
        <p class="settings-section__heading">{{$t('project_settings.budget.title')}}</p>
        <div class="budget__wrapper">
            <div class="budget__left">
                <div class="budget__section">
                    <p>{{$t('project_settings.budget.title')}}</p>
                    <div><input type="number" v-model="projectDetails.budget" /> {{$t('project_settings.budget.currency')}}</div>
                </div>
                <div class="budget__section">
                    <p>{{$t('project_settings.budget.shopping')}}</p>
                    <p>{{projectDetails.purchasePrice}} zł</p>
                </div>
                <div class="budget__section">
                    <p>{{$t('project_settings.budget.remains')}}</p>
                    <p class="color">{{projectDetails.budget - projectDetails.purchasePrice}} {{$t('project_settings.budget.currency')}}</p>
                </div>
            </div>
            <div class="budget__right">
                <div class="budget__progress">
                    <div class="spinner"></div>
                    <template v-if="projectDetails.budget > 0 ">
                        <span>{{ Math.ceil(((projectDetails.budget - projectDetails.purchasePrice) * 100) / projectDetails.budget)}} %</span>
                    </template>
                    <template v-else>
                        <span class="percent">0%</span>

<!--                        <div class="circle-wrap">-->
<!--                            <div class="circle">-->
<!--                                <div class="mask full">-->
<!--                                    <div class="fill"></div>-->
<!--                                </div>-->
<!--                                <div class="mask half">-->
<!--                                    <div class="fill"></div>-->
<!--                                </div>-->
<!--                                <div class="inside-circle"> 75% </div>-->
<!--                            </div>-->
<!--                        </div>-->
                    </template>
                </div>
            </div>
            <div class="budget__button project-add__button furniture__button">
                <button @click="saveBudget">{{$t('project_settings.budget.button_save')}}</button>
            </div>
        </div>

    </div>
</template>

<script>
import {useI18n} from "vue-i18n";
import axios from "axios";
import authHelper from "@/helpsers/auth.helper";
import router from "@/router";
import ApiHelper from "@/helpsers/api.helper";
import {inject, ref, toRefs} from "vue";
import AlertHelper from "@/helpsers/alert.helper";

export default {
    name: "Budget",
    props: {
        project: {
            type: Object,
            default: null
        }
    },
    setup(props) {
        const {t} = useI18n(),
            alert = inject('alert');
        const { project: projectDetails } = toRefs(props);

        function saveBudget() {
            const data = {
                id: router.currentRoute.value.params.id,
                budget: projectDetails.value.budget
            }

            axios.put(ApiHelper.getEditProjectUrl(),data, {
                headers: authHelper.authHeader()
            })
            .then((result) => {
                AlertHelper.show(alert,t('project_settings.budget.save_success_title'),t('project_settings.budget.save_success_desc'));
            })
            .catch(({response}) => {
                let errorMessage = ApiHelper.getResponseMessage(response?.data?.code);
                AlertHelper.show(alert, errorMessage, '', 'error');
            })
        }

        return {
            projectDetails,
            saveBudget,
        }
    }
}
</script>

<style scoped lang="scss">
.circle-wrap {
    margin: 150px auto;
    width: 150px;
    height: 150px;
    background: #fefcff;
    border-radius: 50%;
    border: 1px solid #cdcbd0;
}

.circle-wrap .circle .mask,
.circle-wrap .circle .fill {
    width: 150px;
    height: 150px;
    position: absolute;
    border-radius: 50%;
}

.circle-wrap .circle .mask {
    clip: rect(0px, 150px, 150px, 75px);
}

.circle-wrap .inside-circle {
    width: 122px;
    height: 122px;
    border-radius: 50%;
    background: #d2eaf1;
    line-height: 120px;
    text-align: center;
    margin-top: 14px;
    margin-left: 14px;
    color: #1e51dc;
    position: absolute;
    z-index: 100;
    font-weight: 700;
    font-size: 2rem;
}

/* color animation */

/* 3rd progress bar */
.mask .fill {
    clip: rect(0px, 75px, 150px, 0px);
    background-color: #227ded;
}

.mask.full,
.circle .fill {
    animation: fill ease-in-out 3s;
    transform: rotate(135deg);
}

@keyframes fill{
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(135deg);
    }
}
.budget {
    &__wrapper {
        flex-wrap: wrap;
    }
    &__button {
        width: 100%;
        text-align: right;
        margin: 10px 0;
        z-index: 1;

        @media screen and (max-width: 500px) {
            text-align: center;
        }

        button {
            &:hover {
                cursor: pointer;
                background: #e35748;
            }
        }

    }
}
</style>